import type { Ref } from "vue";
import type { IUseListFilterOptions } from "./use-list-filter";
import type { IUseListLimitOptions } from "./use-list-limit";
import useListFilter from "./use-list-filter";
import useListLimit from "./use-list-limit";

export * from "./use-list-filter";
export * from "./use-list-limit";

export type IUseListOptions = IUseListLimitOptions & IUseListFilterOptions;

export default function useList<T>(items: Ref<T[]>, options: IUseListOptions): Ref<T[]> {
  const limitedItems = useListLimit(items, options);
  const filteredItems = useListFilter(limitedItems, options);

  return filteredItems;
}
